var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"emptypage"},[_c('div',{staticClass:"contentwrap"},[_c('img',{attrs:{"src":_vm.imageUrl}}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"btn",domProps:{"textContent":_vm._s(_vm.buttonName)},on:{"click":_vm.handleButtonClick}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-826bf80c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./lib/pages/_emptypage/index.vue
// module id = 8Vhm
// module chunks = 1